import { BonusComparatorIcon } from "../icons";
import Create from "./Create";
import Edit from "./Edit";
import List from "./List";

export default {
	icon: BonusComparatorIcon,
	list: List,
	create: Create,
	edit: Edit,
	options: {
		group: "admin",
		roles: ["admin"],
	},
};
